import { Alert } from '@mui/material'

import { useTexts } from '../useTexts'

export function Body() {
  const texts = useTexts()

  return <Alert severity="success">{texts.cardText}</Alert>
}
